export default __webpack_public_path__ + "static/media/loginPic.b8da1498.png";